import { useState } from "react";
import History1 from "assets/common/company/history1.png";
import History2 from "assets/common/company/history2.png";
import History3 from "assets/common/company/history3.png";

const History = ({ type }: { type: string }) => {
    const [selectedPeriod, setSelectedPeriod] = useState("2011-2020");

    const getBorderClass = (period: string) => {
        return selectedPeriod === period
            ? type === "air"
                ? "border-air text-[#1d2945] border-b-[3px]"
                : type === "morning"
                  ? "border-morning text-[#1d2945] border-b-[3px]"
                  : type === "quick"
                    ? "border-quick text-[#1d2945] border-b-[3px]"
                    : "border-express text-[#1d2945] border-b-[3px]"
            : "text-[#666]";
    };

    return (
        <div className="flex-1 bg-[#f4f4f4] flex flex-col items-center pb-16 pt-5 responsive1200:pt-0">
            <p className="py-[35px] text-[#333] text-[28px] font-[500] responsive1200:py-[30px] responsive1200:text-[24px]">연혁</p>

            <div className="flex justify-center gap-16 font-bold responsive1200:gap-[26px]">
                {["2011-2020", "2001-2010", "1990-2000"].map(period => (
                    <div
                        key={period}
                        className={`cursor-pointer responsive1200:text-[15px] ${getBorderClass(period)}`}
                        onClick={() => setSelectedPeriod(period)}
                    >
                        {period}
                    </div>
                ))}
            </div>
            <div
                key={selectedPeriod}
                className="my-12 w-full max-w-[1200px] animate-fade-in responsive1200:px-[4%] responsive1200:w-full responsive1200:my-0 responsive1200:mt-[25px]"
            >
                {selectedPeriod === "2011-2020" ? (
                    <div className="relative responsive1200:bg-white responsive1200:py-[25px]">
                        <div className="responsive1200:px-[4%]">
                            <img
                                src={History1}
                                alt="history1"
                                className="left-0 top-0 z-20 absolute responsive1200:relative responsive1200:mx-auto"
                            />
                        </div>
                        <div className="z-10 bg-white py-[65px] ml-[210px] pl-[240px] pr-[50px] relative top-10 right-0 responsive1200:ml-0 responsive1200:pt-0 responsive1200:px-[4%]">
                            <p className="font-[600] text-[#1e2a46] text-[30px] mb-10  responsive1200:text-[25px] responsive1200:mb-0">
                                2011-2020
                            </p>
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px] w-12">2019</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[19px] text-center w-6 responsive1200:text-[18px]">
                                            12
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">국내/해외 협력 거래선 9,000개사 등록 완료</p>
                                    </div>
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            09
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">독일 뮌헨 사무소 개설</p>
                                    </div>
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            05
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">모닝특송·모닝행낭 물류서비스 상품 출시</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px] w-12">2018</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            04
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">모닝퀵서비스·모닝화물 물류서비스 상품 출시</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px] w-12">2017</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[19px] text-center w-6 responsive1200:text-[18px]">
                                            11
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">국내택배 서부지역센타 (경기도 부천시) 설립</p>
                                    </div>
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            02
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">국내/해외 협력 거래선 7,000개사 등록완료</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px] w-12">2016</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            24
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">프랑스 파리 사무소 개설</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px] w-12">2015</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[19px] text-center w-6 responsive1200:text-[18px]">
                                            07
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">국내/해외 협력 거래선 5,000개사 등록완료</p>
                                    </div>
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            01
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">국내외 3PL·직구·직판 물류 서비스 진출</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px] w-12">2014</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            07
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">서울 수도권 지방간 노선차량 운행 진출</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px] w-12">2013</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            03
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">국내택배 서부지역센타 (경기도 안산시) 설립</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px] w-12">2012</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            10
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">국내/해외 10가지 서비스 상품 출시</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px] w-12">2011</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            05
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">국내택배 동부지역센타 (경기도 하남시) 설립</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="mt-2 responsive1200:m-0" />
                        </div>
                    </div>
                ) : selectedPeriod === "2001-2010" ? (
                    <div className="relative responsive1200:bg-white responsive1200:py-[25px]">
                        <div className="responsive1200:px-[4%]">
                            <img
                                src={History2}
                                alt="history2"
                                className="left-0 top-0 z-20 absolute responsive1200:relative responsive1200:mx-auto"
                            />
                        </div>
                        <div className="z-10 bg-white py-[65px] ml-[210px] pl-[240px] pr-[50px] relative top-10 right-0 responsive1200:ml-0 responsive1200:pt-0 responsive1200:px-[4%]">
                            <p className="font-[600] text-[#1e2a46] text-[30px] mb-10 responsive1200:text-[25px] responsive1200:mb-0">
                                2001 - 2010
                            </p>
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">2010</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            07
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">이태리 밀라노 사무소 개설</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-[62px] responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">2008</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            01
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">
                                            국내택배 경기북부지역센타 (경기도 양주시) 설립
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">2007</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            01
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">보세운송업 등록</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">2005</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[19px] text-center w-6 responsive1200:text-[18px]">
                                            12
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">
                                            국내 / 국제택배 대구 경북지역 HUB터미널 (대구시 이현동) 설립
                                        </p>
                                    </div>
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            03
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">SMS (특송모닝 서비스 상품) 출시</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-[63px] responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">2004</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            01
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">화물자동차 운송사업 등록</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">2003</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            02
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">특송업체 등록</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">2002</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            12
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">
                                            국내모닝택배 전국 HUB터미널 (충북 옥천) 설립
                                        </p>
                                    </div>
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            09
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">
                                            국내모닝택배 서울 / 국내택배 본사 터미널 (고양시 일산) 설립
                                        </p>
                                    </div>
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            05
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">
                                            중국 각 지역별 지사 설립 (상해/북경/청도/광주/소주/소흥 등)
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">2000</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            01
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">국내/해외 전시회 운송전문 업체 등록</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="mt-2 responsive1200:m-0" />
                        </div>
                    </div>
                ) : (
                    <div className="relative  responsive1200:bg-white responsive1200:py-[25px]">
                        <div className="responsive1200:px-[4%]">
                            <img
                                src={History3}
                                alt="history3"
                                className="left-0 top-0 z-20 absolute responsive1200:relative responsive1200:mx-auto"
                            />
                        </div>
                        <div className="z-10 bg-white py-[65px] ml-[210px] pl-[240px] pr-[50px] relative top-10 right-0 responsive1200:ml-0 responsive1200:pt-0 responsive1200:px-[4%]">
                            <p className="font-[600] text-[#1e2a46] text-[30px] mb-10 responsive1200:text-[25px] responsive1200:mb-0">
                                1990 - 2000
                            </p>
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">2000</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            01
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">국내/해외 전시회 운송전문 업체 등록</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-[62px] responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">1999</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            02
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">LA / NY 지사 설립</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">1998</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            03
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">국내 택배 (행낭) 업무 진출</p>
                                    </div>
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            03
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">국내 긴급상업서류 송달업 취득 (교통부)</p>
                                    </div>
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            02
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">독일 프랑크푸르트 사무소 개설</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">1997</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[19px] text-center w-6 responsive1200:text-[18px]">
                                            01
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">영국 런던 사무소 개설</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-[63px] responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">1996</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            05
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">복합 운송 주선업 등록 취득 (교통부)</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">1994</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            12
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">HKG 지사 설립</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">1993</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            07
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">DUBAI / JEDDAH 지사 설립</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-2 responsive1200:m-0" />
                            <div className="flex items-start gap-16 responsive1200:flex-col responsive1200:gap-[12px] responsive1200:py-[25px]">
                                <p className="text-[#0e0057] font-bold text-[20px]">1992</p>
                                <div className="w-full max-w-[605px] leading-8">
                                    <div className="flex items-center gap-5">
                                        <p className="text-[#1744ad] font-[500] text-[18px] text-center w-6 responsive1200:text-[18px]">
                                            05
                                        </p>
                                        <p className="text-[#666] responsive1200:text-[15px]">㈜일신항공해운 법인 설립</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="mt-2 responsive1200:m-0" />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default History;
